import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { returnToDrayage } from '../../service/drayage-sso';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthApiService } from '../../service/auth-api.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'lib-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.css'
})
export class SignUpComponent implements OnInit {
  postObj: any = {
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    phone_number: '',
    company_name: '',
    company_profile: null,
    // company_profile: 'Im a Cargo Owner',
    customer_type: null
  };
  companyProfile: any = [
    { name: 'cargo_owner', dname: "Im a Cargo Owner" },
    { name: 'freight_forwarder', dname: "Im a Freight Forwarder" },
    { name: 'cargo_agent', dname: "Im a Cargo Agent" }
  ];
  description = {
    'cargo owner': {
      name: 'Cargo Owner',
      img: 'cargo_owner_vector_svg_2_2024-10-01_15:21:01.svg',
      description: 'If you import or export your own goods, Atmavaan streamlines your logistics, from booking to compliance, ensuring smooth global trade.'
    },
    'partner': {
      name: 'Channel Partner',
      img: 'partner_vector_svg_2_2024-10-01_14:47:22.svg',
      description: 'If you collaborate with import/export companies, Atmavaan offers platform to enhance partnership coordination and logistics support.'
    }
  }
  reqfield = ['first_name', 'last_name', 'email', 'password', 'company_name']
  validateError: any = {};
  passwordMatchError = {
    len: false,
    letter: false,
    number_symbol: false,
    specialChar: false
  };
  getCounCode: any;
  countryCode: any = '91';
  otpValue = '';
  filteredOptions: any = this.companyProfile;
  filteredCountryCodes: any;
  passwordOpen: boolean = false;
  getOTP: boolean = false;
  spinner: boolean = false;
  otpAuthenticationRes: any;
  flag: any = 'India_flag_svg_397_2022-05-10_06:43:37.svg';
  userAlreadyExist: any;
  ischeck: any;
  AppInfo: any;
  constructor(private authService: AuthApiService, private activeRoute: ActivatedRoute, private route: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }
  ngOnInit(): void {
    this.getCountryCode();
    this.getAppInfo();
  }

  login() {
    // keep drayage's ?redirectUrl so logging in instead still returns there
    const redirectUrl = this.activeRoute.snapshot.queryParamMap.get('redirectUrl');
    this.route.navigate(['/auth/login'], { queryParams: redirectUrl ? { redirectUrl } : {} });
  }

  signUp() {
    this.postObj.phone_number = this.countryCode.concat(' ', this.postObj.phone_number);
    this.postObj["user_name"] = this.postObj.first_name.concat(' ', this.postObj.last_name);
    this.postObj["franchise"] = this.AppInfo && this.AppInfo.id ? this.AppInfo.id + '' : '2'
    this.spinner = true;
    if (!!this.postObj.first_name && !!this.postObj.last_name && !!this.postObj.email &&
      !!this.postObj.company_name && !!this.postObj.phone_number && !!this.postObj.password) {

      this.authService.signUp(this.postObj).subscribe(res => {
        if (res.statusCode == 200) {
          if (!!res.info) {
            // this.spinner = false;
            if (res.info.error && res.info.error == "user_exist") {
              console.log("User Exist");
            } else if (!!res.info && !!res.info.login_info) {
              localStorage.setItem('user', JSON.stringify(res.info.login_info.user));
              localStorage.setItem('x-token', res.info.login_info.token);
              // tell the navbar, otherwise it keeps showing Login / Sign Up until a reload
              this.authService.notifyUserChanged();
              // opened by drayage (?redirectUrl=...): go back there signed in
              if (returnToDrayage(res.info.login_info.token, this.activeRoute.snapshot.queryParamMap.get('redirectUrl'))) {
                return;
              }
              setInterval(() => {
                this.route.navigate(['/main/dashboard'],{queryParams:{reload:true}});
                this.spinner = false;
              }, 150)
            }
          }
        }
      })
    }
  }

  // filterOptionsAndCountryCodes(value?: string, options?: any[], property?: any): any[] {
  //   const filterValue = value.toLowerCase();
  //   return options.filter((option) => option[property].toLowerCase().includes(filterValue));
  // }

  filterOptionsAndCountryCodes(value?: string, options?: any[], properties?: string[]): any[] {
    const filterValue = value?.toLowerCase();
    return options?.filter(option =>
      properties?.some(property =>
        option[property].toLowerCase().includes(filterValue)
      )
    )!;
  }

  getCountryCode() {
    this.authService.getCountryCode().subscribe((res) => {
      if (res.statusCode == 200) {
        this.getCounCode = res.info;
        this.filteredCountryCodes = this.getCounCode;
      }
    })
  }

  getOtp() {
    this.ischeck = true;
    this.flag = this.countryCode == '' ? null : this.flag;
    const hasValidationError = Object.values(this.validation()).some(error => error);
    const passwordError = Object.values(this.passwordValid()).some(error => error);
    if (!hasValidationError && !this.userAlreadyExist && !passwordError) {
      this.getOTP = true;
      // this.ischeck = false;
      let body = {
        "type": "email",
        "value": this.postObj.email,
        "user_name": this.postObj.first_name.concat(' ', this.postObj.last_name),
        "franchise": this.AppInfo && this.AppInfo.id ? this.AppInfo.id + '' : '2'
      }
      this.authService.signUpOtp(body).subscribe((res) => {
      })
    }
  }

  reSendOtp() {
    let body = {
      "type": "email",
      "value": this.postObj.email,
      "user_name": this.postObj.first_name.concat(' ', this.postObj.last_name),
      "franchise": this.AppInfo && this.AppInfo.id ? this.AppInfo.id + '' : '2'
    }
    this.authService.signUpOtp(body).subscribe((res) => {
    })
  }

  OtpAuth() {
    let body = {
      "value": this.postObj.email,
      "otp": this.otpValue,
      "franchise": this.AppInfo && this.AppInfo.id ? this.AppInfo.id + '' : '2'
    }
    this.authService.otpAuthentification(body).subscribe((res) => {
      if (res.statusCode == 200) {
        this.otpAuthenticationRes = res.info;
        if (res.info === true) {
          this.signUp();
        }
      }
    })
  }

  onPhoneNumberInput(event: any, type) {
    const input = event.target.value;
    if (input.length > 10 && type == 'mobileNo') {
      this.postObj.phone_number = input.slice(0, 10);
      event.target.value = this.postObj.phone_number;
    } else if (input.length > 6 && type == 'otp') {
      this.otpValue = input.slice(0, 6);
      event.target.value = this.otpValue;
    }
  }


  validation() {
    this.validateError = this.authService.validation(this.postObj, this.reqfield);
    if (!this.postObj.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.postObj.email)) {
      this.validateError['email'] = true;
    }
    return this.validateError;
  }

  checkUserExist() {
    let body = {
      "value": this.postObj.email,
      "franchise": this.AppInfo.id,
      "type": "mail"
    }
    this.authService.checkUserExist(body).subscribe((res) => {
      if (res.statusCode == 200) {
        this.userAlreadyExist = res.info;
      }
    })
  }

  passwordValid() {
    this.passwordMatchError = {
      number_symbol: !this.postObj.password.match(/[0-9]+/),
      letter: !this.postObj.password.match(/[A-Z]/),
      len: this.postObj.password.length < 8,
      specialChar: !this.postObj.password.match(/[-!$%^&*@#()_+|~=`{}\[\]:";'<>?,.\/]/)
    };

    return this.passwordMatchError;
  }

  getAppInfo() {
    if (isPlatformBrowser(this.platformId)) {
      let domain = window.location.host;
      // console.log
      if (!!localStorage.getItem("appInfo")) {
        this.AppInfo = JSON.parse(localStorage.getItem("appInfo") || "");
      } else {
        this.authService.getAppInfo(domain).subscribe(res => {
          if (res.statusCode == 200) {
            this.AppInfo = res.info;
            localStorage.setItem("appInfo", JSON.stringify(this.AppInfo))
          }
        });
      }
    }

  }

}
